import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import authStyles from '../auth.module.css';

function PasswordCondition({ password, hasUpperCase, signInText }) {
  const hasMinLength = password?.length >= 12;
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecialChar = /[!@#$%^&*()_+|~=`{}[\]:";'<>?,./]/.test(password);

  const hasLetterCombo = hasUpperCase && hasLowerCase;

  const allConditionsMet = hasMinLength && hasLetterCombo && hasSpecialChar;

  const renderItem = (isValid, label) => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        color: isValid ? '#23e223' : 'white',
        fontFamily: 'Montserrat, sans-serif',
        marginBottom: '0px',
      }}
    >
      {isValid && <CheckIcon fontSize="small" />}
      <span>{label}</span>
    </div>
  );

  return (
    <>
      {!allConditionsMet ? (
        <div className={authStyles.conditons}>
          {renderItem(hasMinLength, '12 - 30 Characters')}
          {renderItem(hasLetterCombo, 'Minimum of one uppercase and one lowercase')}
          {renderItem(hasNumber, 'Minimum of one number')}
          {renderItem(hasSpecialChar, 'Minimum of one special character')}
        </div>
      ) : (
        <span
          className={authStyles.linkClass}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: signInText?.signUpContent,
          }}
        />
      )}
    </>
  );
}

export default PasswordCondition;
